import type {
  SavingsDepositGuaranteeScheme,
  SavingsProductType,
  SavingsRateType
} from '@interfaces/Savings.interface';
import type {
  SavingsCustomerType,
  SavingsRole
} from '@interfaces/SavingsCustomer.interface';
import type { SavingsDepositLookup } from '@interfaces/SavingsDeposit.interface';
import BaseApiClient from '../BaseApiClient';
import { SAVINGS_API_VERSION_HEADERS } from '../savings-reference-resource';

export class ApiSavingsReferenceLookups extends BaseApiClient {
  private async fetchAll<T>(url: string): Promise<T[]> {
    const res = await this.client.get(url, {
      headers: SAVINGS_API_VERSION_HEADERS
    });
    return res.data.data;
  }

  cashAccountStates(): Promise<SavingsDepositLookup[]> {
    return this.fetchAll('/savings-cash-account-states');
  }

  customerTypes(): Promise<SavingsCustomerType[]> {
    return this.fetchAll('/savings-customer-types');
  }

  depositGuaranteeSchemes(): Promise<SavingsDepositGuaranteeScheme[]> {
    return this.fetchAll('/savings-deposit-guarantee-schemes');
  }

  depositStatuses(): Promise<SavingsDepositLookup[]> {
    return this.fetchAll('/savings-deposit-statuses');
  }

  interestDestinations(): Promise<SavingsDepositLookup[]> {
    return this.fetchAll('/savings-interest-destinations');
  }

  productTypes(): Promise<SavingsProductType[]> {
    return this.fetchAll('/savings-product-types');
  }

  rateTypes(): Promise<SavingsRateType[]> {
    return this.fetchAll('/savings-rate-types');
  }

  roles(): Promise<SavingsRole[]> {
    return this.fetchAll('/savings-roles');
  }
}

export { savingsReferenceLookupsQueryKeys } from './query-keys';
export {
  useSavingsCashAccountStatesQuery,
  useSavingsCustomerTypesQuery,
  useSavingsDepositGuaranteeSchemesQuery,
  useSavingsDepositStatusesQuery,
  useSavingsInterestDestinationsQuery,
  useSavingsProductTypesQuery,
  useSavingsRateTypesQuery,
  useSavingsRolesQuery
} from './use-savings-reference-lookups-queries';
